import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BNewInteraction } from './new-interaction';
import { HttpClient } from '@angular/common/http';
import { apiUrl } from 'app/common/url-resolver.service';
import { SimplePage } from 'app/common/types';
import { Ajax } from 'app/common/ajax';
import { isNil, omitBy } from 'lodash';
import { map } from 'rxjs/operators';

export type TDraftInteractionParams = {
  pageIndex: number;
  pageSize: number;
  orderBy?: string;
  id?: number;
  inquirerIds?: string;
  teamIds?: string;
  topicIds?: string;
  categoryIds?: string;
  productIds?: string;
  insertedByIds?: string;
  assignedToIds?: string;
  languageIds?: string;
  eventIds?: string;
  createdTs?: string;
  dueDate?: string;
  priority?: string;
  isPublic?: string;
};

@Injectable({ providedIn: 'root' })
export class NewInteractionService {
  constructor(private http: HttpClient) {}

  fetchDraftInteractionsList(
    params: TDraftInteractionParams
  ): Observable<SimplePage<BNewInteraction>> {
    return this.http
      .get<SimplePage<BNewInteraction>>(apiUrl('interactions', 'drafts'), {
        ...Ajax.X_NO_LOADING_OPTIONS,
        params: omitBy(params, isNil),
      })
      .pipe(
        map((response) => {
          return { ...response, records: BNewInteraction.fromRestArray(response.records) };
        })
      );
  }
}
